module.exports = __webpack_public_path__ + "img/settings-purple.c91f5915.svg";